var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDaytimeStress = function SvgDaytimeStress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.964 9.05c.8-.8 2.099-.8 2.9 0l4.746 4.748a1.05 1.05 0 0 1-1.484 1.485l-4.713-4.713-4.005 4.006c-.8.8-2.098.8-2.898 0L6.504 10.57l-4.712 4.713a1.05 1.05 0 0 1-1.484-1.485L5.055 9.05c.8-.8 2.098-.801 2.899 0l4.005 4.005zM15.964.6c.8-.8 2.099-.8 2.9 0l4.746 4.747a1.05 1.05 0 0 1-1.484 1.486L17.413 2.12l-4.005 4.006c-.8.8-2.098.8-2.898 0L6.504 2.12 1.792 6.833A1.05 1.05 0 0 1 .308 5.347L5.055.6c.8-.8 2.098-.8 2.899 0l4.005 4.005z"
  })));
};
export default SvgDaytimeStress;